import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  startDateTitle: {
    id: 'course-authoring.course-outline.status-bar.start-date',
    defaultMessage: 'Fecha de inicio',
  },
  pacingTypeTitle: {
    id: 'course-authoring.course-outline.status-bar.pacing-type',
    defaultMessage: 'Tipo de ritmo',
  },
  pacingTypeSelfPaced: {
    id: 'course-authoring.course-outline.status-bar.pacing-type.self-paced',
    defaultMessage: 'A tu propio ritmo',
  },
  pacingTypeInstructorPaced: {
    id: 'course-authoring.course-outline.status-bar.pacing-type.instructor-Paced',
    defaultMessage: 'Guiado por instructor',
  },
  checklistTitle: {
    id: 'course-authoring.course-outline.status-bar.checklists',
    defaultMessage: 'Listas de verificación',
  },
  checklistCompleted: {
    id: 'course-authoring.course-outline.status-bar.checklists.completed',
    defaultMessage: 'completado',
  },
  highlightEmailsTitle: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails',
    defaultMessage: 'Correos electrónicos de destacados del curso',
  },
  highlightEmailsButton: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails.button',
    defaultMessage: 'Habilitar ahora',
  },
  highlightEmailsEnabled: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails.enabled',
    defaultMessage: 'Habilitado',
  },
  highlightEmailsLink: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails.link',
    defaultMessage: 'Más información',
  },
  courseTagsTitle: {
    id: 'course-authoring.course-outline.status-bar.course-tags',
    defaultMessage: 'Etiquetas del curso',
    description: 'Encabezado de etiquetas del curso en el esquema del curso',
  },
  courseManageTagsLink: {
    id: 'course-authoring.course-outline.status-bar.course-manage-tags-link',
    defaultMessage: 'Administrar etiquetas',
    description: 'Abre el panel para editar etiquetas de contenido',
  },
  videoSharingTitle: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.title',
    defaultMessage: 'Compartición de videos',
  },
  videoSharingLink: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.link',
    defaultMessage: 'Más información',
  },
  videoSharingPerVideoText: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.perVideo.text',
    defaultMessage: 'Por video',
  },
  videoSharingAllOffText: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.allOff.text',
    defaultMessage: 'Ningún video',
  },
  videoSharingAllOnText: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.allOn.text',
    defaultMessage: 'Todos los videos',
  },
});

export default messages;